import React, { useEffect, useState } from 'react';
import './saude.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import PageHeader from '../../components/PageHeader';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import { useInternals } from '../../context/internalContext';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUsers } from '../../context/usersContext';
import useSubmitLock from '../../utils/useSubmitLock';

const DemandaEspontanea = () => {
  const location = useLocation();
  const { internalId } = location.state || {};
  const { listInternals, listSpontaneousDemand, createSpontaneousDemand } = useInternals();
  const { userInfo, buildUnitReadParams } = useUsers();
  const [internalDetails, setInternalDetails] = useState(null);
  const [timeline, setTimeline] = useState([]);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();
  const [form, setForm] = useState({
    queixa: '',
    conduta: '',
    observacao: '',
    procedimento: '',
    procedimentoDesc: '',
    sinais: {
      pa: '',
      p: '',
      t: '',
      hgt: '',
      spo2: '',
    },
  });

  const handleInternalSelect = async (internal) => {
    setInternalDetails(internal);
    setTimeline([]);
    if (!internal?.id) return;
    try {
      const resp = await listSpontaneousDemand({ internal: internal.id });
      setTimeline(resp?.results || []);
    } catch (err) {
      console.error('Erro ao carregar demandas:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSinaisChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, sinais: { ...prev.sinais, [name]: value } }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (!internalDetails?.id) {
        toast.error('Selecione um interno para registrar.');
        return;
      }
      try {
        const payload = {
          internal: internalDetails.id,
          health_professional: userInfo?.id || undefined,
          main_complaint: form.queixa,
          conduct: form.conduta,
          vital_signs: {
            pa: form.sinais.pa || '',
            p: form.sinais.p || '',
            t: form.sinais.t || '',
            hgt: form.sinais.hgt || '',
            spo2: form.sinais.spo2 || '',
          },
          procedure_performed: form.procedimento === 'sim',
          procedure_description: form.procedimento === 'sim' ? form.procedimentoDesc : '',
          observation: form.observacao || '',
        };
        await createSpontaneousDemand(payload);
        const updated = await listSpontaneousDemand({ internal: internalDetails.id });
        setTimeline(updated?.results || []);
      } catch (err) {
        console.error('Erro ao registrar demanda:', err);
      }
    });
  };

  useEffect(() => {
    if (internalId) {
      (async () => {
        try {
          const response = await listInternals(buildUnitReadParams({ id: internalId }));
          const internal = response?.results?.[0];
          if (internal) setInternalDetails(internal);
        } catch (err) {
          console.error('Erro ao carregar interno:', err);
        }
      })();
    }
  }, [internalId, listInternals, buildUnitReadParams]);

  useEffect(() => {
    if (!internalDetails?.id) return;
    (async () => {
      try {
        const resp = await listSpontaneousDemand({ internal: internalDetails.id });
        setTimeline(resp?.results || []);
      } catch (err) {
        console.error('Erro ao carregar demandas:', err);
      }
    })();
  }, [internalDetails?.id, listSpontaneousDemand]);

  const getLatestVitals = (item) => {
    const records = item?.vital_signs_records;
    if (Array.isArray(records) && records.length) return records[0];
    if (records && typeof records === 'object') return records;
    return null;
  };

  const renderVitals = (record) => {
    if (!record) return null;
    return (
      <div className="timeline-vitals">
        <p><strong>Sinais vitais:</strong></p>
        <div className="timeline-vitals-grid">
          <span>PA: {record.pa ?? record.PA ?? '-'}</span>
          <span>P: {record.p ?? record.P ?? '-'}</span>
          <span>T: {record.t ?? record.T ?? '-'}</span>
          <span>HGT: {record.hgt ?? record.HGT ?? '-'}</span>
          <span>SpO₂: {record.spo2 ?? record.SpO2 ?? record.spO2 ?? '-'}</span>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container social-container admission-page'>
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
        />

        <PageHeader
          title="Demanda Espontânea"
          subtitle="Registro de atendimentos espontâneos."
          internalDetails={internalDetails}
        />

        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : (
          <>
        <div className="health-card" style={{ marginTop: 16 }}>
          <form onSubmit={handleSubmit} className="demand-form">
            <div className="demand-row">
              <div className="demand-col flex-1">
                <label>Queixa principal</label>
                <textarea
                  rows={3}
                  name="queixa"
                  value={form.queixa}
                  onChange={handleChange}
                  placeholder="Descreva a queixa principal"
                />
              </div>
            </div>

            <div className="demand-row">
              <div className="demand-col flex-1">
                <label>Conduta</label>
                <textarea
                  rows={3}
                  name="conduta"
                  value={form.conduta}
                  onChange={handleChange}
                  placeholder="Descreva a conduta"
                />
              </div>
            </div>

            <div className="demand-row">
              <div className="demand-col flex-1">
                <label>Observação</label>
                <textarea
                  rows={3}
                  name="observacao"
                  value={form.observacao}
                  onChange={handleChange}
                  placeholder="Observações adicionais"
                />
              </div>
            </div>

            <div className="demand-row vitals" style={{ marginTop: 4 }}>
              <div className="demand-col">
                <label>PA</label>
                <input type="text" name="pa" value={form.sinais.pa} onChange={handleSinaisChange} placeholder="Ex: 120x80" />
              </div>
              <div className="demand-col">
                <label>P</label>
                <input type="text" name="p" value={form.sinais.p} onChange={handleSinaisChange} />
              </div>
              <div className="demand-col">
                <label>T</label>
                <input type="text" name="t" value={form.sinais.t} onChange={handleSinaisChange} />
              </div>
              <div className="demand-col">
                <label>HGT</label>
                <input type="text" name="hgt" value={form.sinais.hgt} onChange={handleSinaisChange} />
              </div>
              <div className="demand-col">
                <label>SpO²</label>
                <input type="text" name="spo2" value={form.sinais.spo2} onChange={handleSinaisChange} />
              </div>
            </div>

            <div className="demand-row">
              <div className="demand-col flex-1">
                <label>Realizado procedimento?</label>
                <div className="health-options-row" style={{ marginTop: 6 }}>
                  <label className="health-option"><input type="radio" name="procedimento" checked={form.procedimento === 'sim'} onChange={() => setForm(prev => ({ ...prev, procedimento: 'sim', procedimentoDesc: '' }))} /> Sim</label>
                  <label className="health-option"><input type="radio" name="procedimento" checked={form.procedimento === 'nao'} onChange={() => setForm(prev => ({ ...prev, procedimento: 'nao', procedimentoDesc: '' }))} /> Não</label>
                </div>
              </div>
              {form.procedimento === 'sim' && (
                <div className="demand-col flex-1">
                  <label>Qual?</label>
                  <input
                    type="text"
                    placeholder="Descreva o procedimento realizado"
                    value={form.procedimentoDesc}
                    onChange={(e) => setForm(prev => ({ ...prev, procedimentoDesc: e.target.value }))}
                  />
                </div>
              )}
            </div>

            <div className="demand-row" style={{ marginTop: 12 }}>
              <button type="submit" className="social-submit-button" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>

        <div className="timeline content" style={{ marginTop: 20 }}>
          <h4>Histórico</h4>
          <ul className="timeline-list">
            {timeline.length > 0 ? (
              timeline.map((item) => (
                <li key={item.id} className="timeline-item">
                  <div className="timeline-date">
                    {item.date ? new Date(item.date).toLocaleString('pt-BR') : ''}
                  </div>
                  <div className="timeline-content">
                    <p><strong>Queixa:</strong> {item.main_complaint || '-'}</p>
                    <p><strong>Conduta:</strong> {item.conduct || '-'}</p>
                    <p><strong>Observação:</strong> {item.observation || '-'}</p>
                    <p><strong>Procedimento:</strong> {item.procedure_performed ? 'Sim' : 'Não'}{item.procedure_description ? ` - ${item.procedure_description}` : ''}</p>
                    {renderVitals(getLatestVitals(item))}
                  </div>
                </li>
              ))
            ) : (
              <p>Nenhuma demanda registrada.</p>
            )}
          </ul>
        </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DemandaEspontanea;
